import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles<Theme, { dark?: boolean }>((theme) => ({
  buttonRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flexShrink: 0,
  },
  buttonLabel: ({ dark }) => ({
    textTransform: 'none',
    fontSize: 20,
    color: dark ? theme.palette.common.black : theme.palette.common.white,
  }),
  menuItem: {
    fontSize: 20,
    height: 51,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  defaultLabel: {
    opacity: 0.5,
  },
  buttonIcon: ({ dark }) => ({
    opacity: dark ? 0.54 : 0.7,
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  }),
  menuItemIcon: {
    minWidth: 0,
    marginRight: theme.spacing(2),
  },
}));
